import { useSelector } from 'react-redux';
import { RootState } from '../../../setup';

const AgingCards = ({color, borderColor, className, title, amount, onClick}) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    return (
        <div
            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end ${className}`}
            style={{
                cursor: 'pointer',
                backgroundColor: color,
                borderRadius: '0.625rem',
                boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.03)',
                borderBottom: `10px solid ${borderColor}`
            }}
            onClick={onClick}
        >
            <div className='card-body text-white ps-5 pe-5'>
                <div className="row">
                    <div className="col-5 d-flex align-items-center">
                        <h1 className={`text-white fw-semibold ${fontSize < 13 ? 'fs-8' : fontSize > 13 ? 'fs-4' : 'fs-6'} mb-0`} style={{fontWeight: 500}}>{title?.includes('undefined') ? '' : title}</h1>
                    </div>
                    <div className="col-7 d-flex justify-content-end align-items-center">
                        <h1 className={'fw-bold text-white mb-0'}>
                            ${amount}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgingCards